// extracted by mini-css-extract-plugin
module.exports = {"footerTagsContainer":"styles_footerTagsContainer__208By","copyright":"styles_copyright__Q1JfP"};